import service from "./service";

async function createInterface(payload) {
  try {
    return await service.createInterface(payload);
  } catch (error) {
    return null;
  }
}

/**
 * @function getInterfaces
 * @param {string} keyword
 * @param {number} limit
 * @param {string} order
 * @param {number} page
 * @param {string} sort
 */
async function getInterfaces(payload) {
  try {
    return await service.getInterfaces(payload);
  } catch (error) {
    return null;
  }
}

async function getInterfaceDetail(payload) {
  try {
    return await service.getInterfaceDetail(payload);
  } catch (error) {
    return null;
  }
}

/*
*
* @param {object} payload
* @param {string} keyword
* */
async function getSeparatedProjects(payload) {
  try {
    return await service.getSeparatedProjects(payload);
  } catch (error) {
    return null;
  }
}

/**
 *
 * @param {object} payload
 * @param {Number} payload.interfaceId
 */
async function deleteInterface(payload) {
  try {
    return await service.deleteInterface(payload);
  } catch (error) {
    return null;
  }
}

export default {
  getSeparatedProjects,
  createInterface,
  getInterfaces,
  getInterfaceDetail,
  deleteInterface,
};
